import React from 'react';
import styled from 'styled-components';
import { IconProps } from './types';

const PDFIcon = (props: IconProps): JSX.Element => (
  // allow prop spreading for svg icon
  // eslint-disable-next-line
  <svg viewBox="0 0 32 32" {...props}>
    <path d="M25 22h-2v1h2v1h-2v2h-1v-5h3v1zM18.5 26h-1.5v-5h1.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5zM14.5 24h-1.5v2h-1v-5h2.5c0.83 0 1.5 0.672 1.5 1.5s-0.67 1.5-1.5 1.5zM10 20v4h-3v-19h10v4.998c0 0.552 0.447 1 1 1h5v8.002h-12c-0.552 0-1 0.447-1 1zM18 5l5 4.96h-5v-4.96zM26 19h-2v-8.98c0.006-0.263-0.092-0.53-0.293-0.73l-5-4.997c-0.187-0.188-0.44-0.293-0.707-0.293h-11c-0.552 0-1 0.448-1 1v19c0 0.553 0.448 1 1 1h3v2c0 0.553 0.448 1 1 1h15c0.553 0 1-0.447 1-1v-7c0-0.553-0.447-1-1-1zM18.5 22c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5h-0.5v-3h0.5zM14.5 22c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1.5v-1h1.5zM9.5 8c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-5zM9.5 11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-5zM9.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-11zM21 16.5c0 0.276-0.224 0.5-0.5 0.5h-11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h11c0.276 0 0.5 0.224 0.5 0.5z" />
  </svg>
);

const StyledPDFIcon = styled(PDFIcon)`
  width: ${({ size = '1rem' }) => size};
  height: ${({ size = '1rem' }) => size};
  vertical-align: middle;
`;
export default StyledPDFIcon;
